import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f570eb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-hunt-scan",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hunt-eyebrow" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "nge-hunt-eyegem",
    viewBox: "0 0 24 24",
    width: "12",
    height: "12",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5 9 L9 4 L15 4 L19 9 L12 20 Z",
      fill: "currentColor"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" The Hunt ")
], -1 /* HOISTED */))
const _hoisted_3 = {
  key: 0,
  class: "nge-hunt-headclock"
}
const _hoisted_4 = ["aria-pressed", "title", "aria-label"]
const _hoisted_5 = {
  viewBox: "0 0 16 16",
  width: "14",
  height: "14",
  "aria-hidden": "true"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "1.75",
  y: "2.75",
  width: "12.5",
  height: "10.5",
  rx: "2",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.4"
}, null, -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M10 3v10",
  stroke: "currentColor",
  "stroke-width": "1.4"
}, null, -1 /* HOISTED */))
const _hoisted_8 = {
  key: 0,
  d: "M11.2 5.5h1.8M11.2 8h1.8M11.2 10.5h1.8",
  stroke: "currentColor",
  "stroke-width": "1.2",
  "stroke-linecap": "round"
}
const _hoisted_9 = ["title", "aria-label", "aria-expanded"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.5 7.5 6 4l3.5 3.5",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "nge-hunt-tabs",
  role: "tablist",
  "aria-label": "Hunts"
}
const _hoisted_13 = ["aria-selected", "title", "onClick"]
const _hoisted_14 = {
  key: 1,
  class: "nge-hunt-body"
}
const _hoisted_15 = {
  key: 0,
  class: "nge-hunt-error"
}
const _hoisted_16 = {
  key: 1,
  class: "nge-hunt-muted"
}
const _hoisted_17 = {
  key: 2,
  class: "nge-hunt-muted"
}
const _hoisted_18 = {
  key: 3,
  class: "nge-hunt-muted"
}
const _hoisted_19 = {
  key: 4,
  class: "nge-hunt-error"
}
const _hoisted_20 = {
  key: 5,
  class: "nge-hunt-muted"
}
const _hoisted_21 = { class: "nge-hunt-body" }
const _hoisted_22 = {
  key: 0,
  class: "nge-hunt-titlerow"
}
const _hoisted_23 = { class: "nge-hunt-title" }
const _hoisted_24 = {
  key: 0,
  class: "nge-hunt-clock"
}
const _hoisted_25 = { class: "nge-hunt-clock-label" }
const _hoisted_26 = { class: "nge-hunt-clock-time" }
const _hoisted_27 = {
  key: 1,
  class: "nge-hunt-brief"
}
const _hoisted_28 = {
  key: 2,
  class: "nge-hunt-when"
}
const _hoisted_29 = {
  key: 0,
  class: "nge-hunt-slim"
}
const _hoisted_30 = { class: "nge-hunt-slim-row" }
const _hoisted_31 = ["title"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "found", -1 /* HOISTED */))
const _hoisted_33 = ["title"]
const _hoisted_34 = {
  key: 0,
  class: "nge-hunt-slim-row"
}
const _hoisted_35 = ["aria-checked", "title", "onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "12",
  height: "12",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 9 L9 4 L15 4 L19 9 L12 20 Z",
    fill: "currentColor"
  })
], -1 /* HOISTED */))
const _hoisted_37 = ["disabled", "title"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  width: "13",
  height: "13",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 4L3 7l3 3M3.5 7H10a3 3 0 0 1 0 6H8",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 2,
  class: "nge-hunt-slim-done"
}
const _hoisted_43 = {
  key: 3,
  class: "nge-hunt-slim-news nge-hunt-news--pending",
  role: "status"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Checking…", -1 /* HOISTED */))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "nge-hunt-hud" }
const _hoisted_47 = { class: "nge-hunt-read" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hunt-read-label" }, "Found", -1 /* HOISTED */))
const _hoisted_49 = { class: "nge-hunt-read-val" }
const _hoisted_50 = { class: "nge-hunt-read" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hunt-read-label" }, "Gems", -1 /* HOISTED */))
const _hoisted_52 = { class: "nge-hunt-read-val" }
const _hoisted_53 = {
  key: 0,
  class: "nge-hunt-read-sub"
}
const _hoisted_54 = {
  key: 1,
  class: "nge-hunt-read-sub"
}
const _hoisted_55 = {
  class: "nge-hunt-read",
  title: "Your clock started when you first opened the Hunt, and runs once"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hunt-read-label" }, "Time", -1 /* HOISTED */))
const _hoisted_57 = { class: "nge-hunt-read-val nge-hunt-read-time" }
const _hoisted_58 = { class: "nge-hunt-read-sub" }
const _hoisted_59 = ["title"]
const _hoisted_60 = {
  key: 1,
  class: "nge-hunt-used"
}
const _hoisted_61 = {
  key: 2,
  class: "nge-hunt-controls"
}
const _hoisted_62 = {
  key: 0,
  class: "nge-hunt-kinds",
  role: "radiogroup",
  "aria-label": "Which gem Ctrl + Click drops"
}
const _hoisted_63 = ["aria-checked", "title", "onClick"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "15",
  height: "15",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 9 L9 4 L15 4 L19 9 L12 20 Z",
    fill: "currentColor"
  })
], -1 /* HOISTED */))
const _hoisted_65 = { class: "nge-hunt-kind-word" }
const _hoisted_66 = { class: "nge-hunt-kind-count" }
const _hoisted_67 = {
  class: "nge-hunt-switch",
  title: "On: each gem is checked as it lands. Off: gems wait until you press Submit."
}
const _hoisted_68 = ["checked"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-hunt-switch-track",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-hunt-switch-knob" })
], -1 /* HOISTED */))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hunt-switch-text" }, "Check each gem as it lands", -1 /* HOISTED */))
const _hoisted_71 = {
  key: 1,
  class: "nge-hunt-submitrow"
}
const _hoisted_72 = ["disabled"]
const _hoisted_73 = ["disabled"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  width: "13",
  height: "13",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 4L3 7l3 3M3.5 7H10a3 3 0 0 1 0 6H8",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_75 = {
  key: 3,
  class: "nge-hunt-switch nge-hunt-switch--edge",
  title: "On: the cells glow teal where they run out of the data. An Extend gem there is the edge of the dataset and uses no gem."
}
const _hoisted_76 = ["checked"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-hunt-switch-track",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-hunt-switch-knob" })
], -1 /* HOISTED */))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hunt-switch-text" }, "Show the edge of the dataset", -1 /* HOISTED */))
const _hoisted_79 = {
  key: 4,
  class: "nge-hunt-news nge-hunt-news--pending",
  role: "status"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-hunt-news-head" }, "Checking…", -1 /* HOISTED */))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = { class: "nge-hunt-news-head" }
const _hoisted_83 = { class: "nge-hunt-news-text" }
const _hoisted_84 = {
  key: 6,
  class: "nge-hunt-log",
  "aria-label": "Your answers before"
}
const _hoisted_85 = { class: "nge-hunt-done-head" }
const _hoisted_86 = { class: "nge-hunt-done-why" }
const _hoisted_87 = {
  key: 0,
  class: "nge-hunt-muted"
}
const _hoisted_88 = ["aria-expanded"]
const _hoisted_89 = { "aria-hidden": "true" }
const _hoisted_90 = {
  key: 0,
  class: "nge-hunt-reportform"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Put the crosshair on it, or type x, y, z as the coordinate bar shows them. Say what it is, and send it. No gem is used.", -1 /* HOISTED */))
const _hoisted_92 = { class: "nge-hunt-reportrow" }
const _hoisted_93 = {
  class: "nge-hunt-kinds nge-hunt-reportkinds",
  role: "radiogroup",
  "aria-label": "What it is"
}
const _hoisted_94 = ["aria-checked", "onClick"]
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "13",
  height: "13",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 9 L9 4 L15 4 L19 9 L12 20 Z",
    fill: "currentColor"
  })
], -1 /* HOISTED */))
const _hoisted_96 = { class: "nge-hunt-kind-word" }
const _hoisted_97 = ["disabled"]
const _hoisted_98 = {
  key: 0,
  class: "nge-hunt-report-done",
  role: "status"
}
const _hoisted_99 = {
  key: 3,
  class: "nge-hunt-actions"
}
const _hoisted_100 = ["disabled"]
const _hoisted_101 = {
  key: 0,
  class: "nge-hunt-btn-sub"
}
const _hoisted_102 = ["title", "onClick"]
const _hoisted_103 = { class: "nge-hunt-congrats" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-hunt-congrats-head" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-hunt-congrats-big" }, "Congratulations"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "nge-hunt-congrats-small" }, "hunters!")
], -1 /* HOISTED */))
const _hoisted_105 = {
  key: 0,
  class: "nge-hunt-muted"
}
const _hoisted_106 = ["src"]
const _hoisted_107 = {
  key: 2,
  class: "nge-hunt-mine"
}
const _hoisted_108 = {
  key: 3,
  class: "nge-hunt-mymedal nge-hunt-mymedal--speed"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "hunt/fastest-128.png",
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_110 = ["disabled"]
const _hoisted_111 = {
  key: 5,
  class: "nge-hunt-answersnote"
}
const _hoisted_112 = {
  key: 5,
  class: "nge-hunt-error",
  role: "alert"
}
const _hoisted_113 = ["aria-expanded"]
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Instructions", -1 /* HOISTED */))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "10",
  height: "10",
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.5 4.5 6 8l3.5-3.5",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_116 = [
  _hoisted_114,
  _hoisted_115
]
const _hoisted_117 = {
  key: 7,
  class: "nge-hunt-howpanel"
}
const _hoisted_118 = ["innerHTML"]
const _hoisted_119 = {
  class: "nge-hunt-key",
  "aria-label": "What the colors mean"
}
const _hoisted_120 = ["fill"]
const _hoisted_121 = {
  key: 0,
  class: "nge-hunt-keyitem nge-hunt-keyitem--wide"
}
const _hoisted_122 = {
  class: "nge-hunt-medalrow",
  "aria-label": "Medals"
}
const _hoisted_123 = ["title"]
const _hoisted_124 = ["src"]
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-hunt-medalmini",
  title: "Speed: the fastest to find them all (or the most, if nobody finds all), from your first open of the Hunt. One try."
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "hunt/fastest-128.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("b", { class: "nge-hunt-tierword--speed" }, "Speed"),
  /*#__PURE__*/_createElementVNode("small", null, "fastest")
], -1 /* HOISTED */))
const _hoisted_126 = {
  key: 1,
  class: "nge-hunt-fine"
}
const _hoisted_127 = {
  key: 8,
  class: "nge-hunt-board",
  "aria-label": "Top hunters"
}
const _hoisted_128 = { class: "nge-hunt-label" }
const _hoisted_129 = { class: "nge-hunt-rank" }
const _hoisted_130 = { class: "nge-hunt-who" }
const _hoisted_131 = {
  key: 0,
  src: "hunt/fastest-128.png",
  class: "nge-hunt-speedmark",
  title: "Fastest",
  alt: "Fastest"
}
const _hoisted_132 = ["title"]
const _hoisted_133 = { class: "nge-hunt-found" }
const _hoisted_134 = {
  key: 0,
  class: "nge-hunt-gemcount"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("aside", {
    ref: "boxEl",
    class: _normalizeClass(["nge-hunt", { 'nge-hunt--dragging': $setup.dragging, 'nge-hunt--live': $setup.phase === 'live', 'nge-hunt--mini': $setup.mini }]),
    style: _normalizeStyle($setup.posStyle),
    role: "dialog",
    "aria-label": "The Hunt"
  }, [
    _createCommentVNode(" Pyr's instrument chrome, as the notification window carries it (no corner brackets: Ames 2026-10-21). "),
    _hoisted_1,
    _createElementVNode("header", {
      class: "nge-hunt-head",
      title: "Drag to move",
      onPointerdown: _cache[5] || (_cache[5] = (...args) => ($setup.startDrag && $setup.startDrag(...args)))
    }, [
      _hoisted_2,
      ($setup.mini && $setup.clock)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString($setup.clock.label), 1 /* TEXT */),
            _createElementVNode("b", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.clockParts($setup.clock.value), (p, i) => {
                return (_openBlock(), _createElementBlock("i", {
                  key: i,
                  class: _normalizeClass({ 'nge-digit': p.d })
                }, _toDisplayString(p.c), 3 /* TEXT, CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.opened && $setup.phase === 'live' && !$setup.mini)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: _normalizeClass(["nge-hunt-panelsbtn", { 'nge-hunt-panelsbtn--on': $setup.huntPrefs.panels }]),
            "aria-pressed": $setup.huntPrefs.panels,
            title: $setup.huntPrefs.panels ? 'Hide the Annotations and Selection panels while hunting' : 'Show the Annotations and Selection panels (your gems in Found and Missed)',
            "aria-label": $setup.huntPrefs.panels ? 'Hide the side panels' : 'Show the side panels',
            onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
            onClick: _cache[1] || (_cache[1] = $event => ($setup.setHuntPanels(!$setup.huntPrefs.panels)))
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              ($setup.huntPrefs.panels)
                ? (_openBlock(), _createElementBlock("path", _hoisted_8))
                : _createCommentVNode("v-if", true)
            ]))
          ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_4))
        : _createCommentVNode("v-if", true),
      ($setup.phase !== 'ended')
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: _normalizeClass(["nge-hunt-caret", { 'nge-hunt-caret--down': $setup.mini }]),
            title: $setup.mini ? 'Show everything' : 'Make it small',
            "aria-label": $setup.mini ? 'Show everything' : 'Make it small',
            "aria-expanded": !$setup.mini,
            onPointerdown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
            onClick: $setup.toggleMini
          }, _hoisted_11, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_9))
        : _createCommentVNode("v-if", true),
      _createElementVNode("button", {
        class: "nge-hunt-x",
        title: "Close",
        "aria-label": "Close",
        onPointerdown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
        onClick: _cache[4] || (_cache[4] = $event => ($setup.emit('hide')))
      }, "×", 32 /* HYDRATE_EVENTS */)
    ], 32 /* HYDRATE_EVENTS */),
    ($setup.otherHunts.length > 1 && !$setup.mini)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.otherHunts, (h) => {
            return (_openBlock(), _createElementBlock("button", {
              key: h.id,
              class: _normalizeClass(["nge-hunt-tab", { 'nge-hunt-tab--on': $setup.hunt?.id === h.id, 'nge-hunt-tab--live': $setup.phaseNow(h) === 'live' }]),
              role: "tab",
              "aria-selected": $setup.hunt?.id === h.id,
              title: h.title,
              onClick: $event => ($setup.emit('pick', h.id))
            }, _toDisplayString(h.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_13))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    (!$setup.hunt)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          ($props.test && $setup.huntState.error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString($setup.huntState.error), 1 /* TEXT */))
            : ($props.test)
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Opening your test run…"))
              : ($props.huntId === -2)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, "That Hunt is over and no longer listed."))
                : ($setup.huntState.loading || $props.huntId === -1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, "Looking for the Hunt…"))
                  : ($setup.huntState.error)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString($setup.huntState.error), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("p", _hoisted_20, "No Hunt right now. When one is coming, it is announced in your notifications."))
        ]))
      : (!($setup.mini && $setup.phase === 'announced' && !$setup.error))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createCommentVNode(" Small before the start: the header alone, with its countdown (Ames 2026-10-22: \"this looks wonky\") "),
            _createElementVNode("div", _hoisted_21, [
              (!$setup.mini)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("h2", _hoisted_23, _toDisplayString($setup.hunt.title), 1 /* TEXT */),
                    ($setup.clock)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("span", _hoisted_25, _toDisplayString($setup.clock.label), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.clockParts($setup.clock.value), (p, i) => {
                              return (_openBlock(), _createElementBlock("i", {
                                key: i,
                                class: _normalizeClass({ 'nge-digit': p.d })
                              }, _toDisplayString(p.c), 3 /* TEXT, CLASS */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              (!$setup.mini)
                ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString($setup.briefShort), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($setup.phase === 'announced' && !$setup.mini)
                ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString($setup.localTime($setup.hunt.start_at)) + " until " + _toDisplayString($setup.localTime($setup.hunt.end_at)), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" While it runs "),
              ($setup.phase === 'live')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createCommentVNode(" Small (Ames 2026-10-21: \"a slim version of the main functions\"): found of all, gems left,\n             the gem switch, Submit, and the last answer, in two thin rows. "),
                    ($setup.mini && $setup.run)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("span", {
                              class: "nge-hunt-slim-read",
                              title: `${$setup.run.found} of ${$setup.run.of} found`
                            }, [
                              (_openBlock(), _createElementBlock("b", {
                                key: 'f' + $setup.run.found,
                                class: "nge-hunt-pop"
                              }, _toDisplayString($setup.run.found), 1 /* TEXT */)),
                              _createElementVNode("i", null, "/" + _toDisplayString($setup.run.of), 1 /* TEXT */),
                              _hoisted_32
                            ], 8 /* PROPS */, _hoisted_31),
                            _createCommentVNode(" Gems left as a count, no fraction, so only the finds read as one (Ames 2026-10-22: \"kind of confusing to see the 7/10 and 8/15\") "),
                            _createElementVNode("span", {
                              class: "nge-hunt-slim-read",
                              title: `${$setup.run.gems_left} of ${$setup.run.budget} gems left`
                            }, [
                              (_openBlock(), _createElementBlock("b", {
                                key: 'g' + $setup.run.gems_left,
                                class: "nge-hunt-pop"
                              }, _toDisplayString($setup.run.gems_left), 1 /* TEXT */)),
                              _createElementVNode("small", null, _toDisplayString($setup.run.gems_left === 1 ? 'gem left' : 'gems left'), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_33)
                          ]),
                          ($setup.opened && !$setup.run.done && ($setup.kinds.length > 1 || !$setup.huntPrefs.auto))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                ($setup.kinds.length > 1)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: _normalizeClass(["nge-hunt-kinds nge-hunt-kinds--slim", { 'nge-hunt-kinds--fill': $setup.huntPrefs.auto }]),
                                      role: "radiogroup",
                                      "aria-label": "Which gem Ctrl + Click drops"
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.kinds, (k) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: k,
                                          class: _normalizeClass(["nge-hunt-kind", [`nge-hunt-kind--${k}`, { 'nge-hunt-kind--on': $setup.huntState.kind === k }]]),
                                          role: "radio",
                                          "aria-checked": $setup.huntState.kind === k,
                                          title: $setup.kindTitle(k),
                                          onClick: $event => ($setup.choose(k))
                                        }, [
                                          _hoisted_36,
                                          _createElementVNode("span", null, _toDisplayString($setup.KIND[k].word), 1 /* TEXT */)
                                        ], 10 /* CLASS, PROPS */, _hoisted_35))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ], 2 /* CLASS */))
                                  : _createCommentVNode("v-if", true),
                                (!$setup.huntPrefs.auto)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      class: _normalizeClass(["nge-hunt-submit nge-hunt-submit--slim", { 'nge-hunt-submit--alone': $setup.kinds.length < 2 }]),
                                      disabled: !$setup.huntState.waiting,
                                      title: $setup.huntState.waiting ? '' : 'Drop gems, then submit',
                                      onClick: _cache[6] || (_cache[6] = (...args) => ($setup.submitWaiting && $setup.submitWaiting(...args)))
                                    }, _toDisplayString($setup.huntState.waiting ? `Submit ${$setup.huntState.waiting}` : 'Submit'), 11 /* TEXT, CLASS, PROPS */, _hoisted_37))
                                  : _createCommentVNode("v-if", true),
                                (!$setup.huntPrefs.auto)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      class: "nge-hunt-takeback nge-hunt-takeback--slim",
                                      disabled: !$setup.huntState.waiting,
                                      title: "Take back your last gem (not sent yet)",
                                      "aria-label": "Take back your last gem",
                                      onClick: _cache[7] || (_cache[7] = (...args) => ($setup.takeBackGem && $setup.takeBackGem(...args)))
                                    }, _hoisted_40, 8 /* PROPS */, _hoisted_38))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true),
                          (!$setup.opened)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "nge-hunt-btn nge-hunt-btn--primary nge-hunt-btn--slim",
                                disabled: !!$setup.busy,
                                onClick: $setup.go
                              }, _toDisplayString($setup.busy === 'go' ? 'Opening…' : $setup.onDataset ? 'Open the Hunt' : `Open on ${$setup.datasetName}`), 9 /* TEXT, PROPS */, _hoisted_41))
                            : _createCommentVNode("v-if", true),
                          ($setup.run.done)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_42, [
                                _createTextVNode(_toDisplayString($setup.doneWhy.head), 1 /* TEXT */),
                                _createElementVNode("span", null, _toDisplayString($setup.doneWhy.short), 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("v-if", true),
                          ($setup.huntState.pending)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
                            : ($setup.newsLine)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: $setup.news?.at,
                                  class: _normalizeClass(["nge-hunt-slim-news", [`nge-hunt-news--${$setup.newsLine.cls}`, { 'nge-hunt-news--ext': $setup.newsLine.ext }]]),
                                  role: "status"
                                }, [
                                  _createElementVNode("b", null, _toDisplayString($setup.newsLine.head), 1 /* TEXT */),
                                  _createElementVNode("span", null, _toDisplayString($setup.newsLine.text), 1 /* TEXT */),
                                  ($setup.newsLine.other && $setup.kinds.includes($setup.newsLine.other))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "nge-hunt-news-switch",
                                        onClick: _cache[8] || (_cache[8] = $event => ($setup.choose($setup.newsLine.other)))
                                      }, "Switch to " + _toDisplayString($setup.KIND[$setup.newsLine.other].word), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                                ], 2 /* CLASS */))
                              : _createCommentVNode("v-if", true)
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($setup.opened && $setup.run && !$setup.mini)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createCommentVNode(" The HUD: what is found, what is left, the medal so far "),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _hoisted_48,
                              _createElementVNode("span", _hoisted_49, [
                                (_openBlock(), _createElementBlock("b", {
                                  key: 'f' + $setup.run.found,
                                  class: "nge-hunt-pop"
                                }, _toDisplayString($setup.run.found), 1 /* TEXT */)),
                                _createElementVNode("i", null, "/" + _toDisplayString($setup.run.of), 1 /* TEXT */)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                              _createCommentVNode(" Gems LEFT, \"of\" the total, so it never reads as a score beside Found (Ames 2026-10-26, Nseraf #259: \"8+4= more than 8\") "),
                              _hoisted_51,
                              _createElementVNode("span", _hoisted_52, [
                                (_openBlock(), _createElementBlock("b", {
                                  key: 'g' + $setup.run.gems_left,
                                  class: "nge-hunt-pop"
                                }, _toDisplayString($setup.run.gems_left), 1 /* TEXT */)),
                                _createElementVNode("i", null, " of " + _toDisplayString($setup.run.budget), 1 /* TEXT */)
                              ]),
                              ($setup.huntState.waiting)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString($setup.huntState.waiting) + " waiting", 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString($setup.run.gems_left === 0 ? 'none left' : 'left'), 1 /* TEXT */))
                            ]),
                            _createCommentVNode(" The medal stays a secret until the end (Ames 2026-10-21: \"do we want to reveal what achievement they have before they win it?\"); the clock shows instead. "),
                            _createElementVNode("div", _hoisted_55, [
                              _hoisted_56,
                              _createElementVNode("span", _hoisted_57, _toDisplayString($setup.yourTime || '0m 00s'), 1 /* TEXT */),
                              _createElementVNode("span", _hoisted_58, _toDisplayString($setup.run.done ? 'final' : 'one try'), 1 /* TEXT */)
                            ])
                          ]),
                          _createCommentVNode(" One gem per chance: gold while left, dark once dropped "),
                          ($setup.pips.length && !$setup.mini)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "nge-hunt-pips",
                                style: _normalizeStyle({ '--pips': $setup.pips.length }),
                                title: `${$setup.run.gems_left} of ${$setup.run.budget} gems left`,
                                "aria-hidden": "true"
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pips, (used, i) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: i,
                                    class: _normalizeClass(["nge-hunt-pip", { 'nge-hunt-pip--used': used }])
                                  }, null, 2 /* CLASS */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 12 /* STYLE, PROPS */, _hoisted_59))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" Where the used gems went, so found, missed and left add up to the total "),
                          (!$setup.mini && $setup.run.gems_used > 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString($setup.run.gems_used) + " " + _toDisplayString($setup.run.gems_used === 1 ? 'gem' : 'gems') + " used: " + _toDisplayString($setup.run.found) + " right, " + _toDisplayString($setup.missed) + " missed", 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (!$setup.run.done)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                ($setup.kinds.length > 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.kinds, (k) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: k,
                                          class: _normalizeClass(["nge-hunt-kind", [`nge-hunt-kind--${k}`, { 'nge-hunt-kind--on': $setup.huntState.kind === k }]]),
                                          role: "radio",
                                          "aria-checked": $setup.huntState.kind === k,
                                          title: $setup.kindTitle(k),
                                          onClick: $event => ($setup.choose(k))
                                        }, [
                                          _hoisted_64,
                                          _createElementVNode("span", _hoisted_65, _toDisplayString($setup.KIND[k].word), 1 /* TEXT */),
                                          _createElementVNode("span", _hoisted_66, [
                                            _createTextVNode(_toDisplayString($setup.run.found_by?.[k] ?? 0), 1 /* TEXT */),
                                            _createElementVNode("i", null, "/" + _toDisplayString($setup.run.of_by?.[k] ?? 0), 1 /* TEXT */)
                                          ])
                                        ], 10 /* CLASS, PROPS */, _hoisted_63))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("label", _hoisted_67, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    role: "switch",
                                    checked: $setup.huntPrefs.auto,
                                    onChange: $setup.onAutoChange
                                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_68),
                                  _hoisted_69,
                                  _hoisted_70
                                ]),
                                (!$setup.huntPrefs.auto)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                      _createElementVNode("button", {
                                        class: "nge-hunt-submit",
                                        disabled: !$setup.huntState.waiting,
                                        onClick: _cache[9] || (_cache[9] = (...args) => ($setup.submitWaiting && $setup.submitWaiting(...args)))
                                      }, _toDisplayString($setup.huntState.waiting ? `Submit ${$setup.huntState.waiting} ${$setup.huntState.waiting === 1 ? 'gem' : 'gems'}` : 'Drop gems, then submit'), 9 /* TEXT, PROPS */, _hoisted_72),
                                      _createCommentVNode(" A gem dropped by mistake comes off before Submit (Ames 2026-10-26, from Celia) "),
                                      _createElementVNode("button", {
                                        class: "nge-hunt-takeback",
                                        disabled: !$setup.huntState.waiting,
                                        title: "Take back your last gem (not sent yet)",
                                        onClick: _cache[10] || (_cache[10] = (...args) => ($setup.takeBackGem && $setup.takeBackGem(...args)))
                                      }, [
                                        _hoisted_74,
                                        _createTextVNode(" Take back ")
                                      ], 8 /* PROPS */, _hoisted_73)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" The cells glow teal where they run out of the data; off if it distracts (Ames 2026-10-23) "),
                          ($setup.opened && $setup.hunt?.bounds_nm)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_75, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  role: "switch",
                                  checked: $setup.huntPrefs.edges,
                                  onChange: $setup.onEdgesChange
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_76),
                                _hoisted_77,
                                _hoisted_78
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" The last gem's answer "),
                          ($setup.huntState.pending)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, _hoisted_81))
                            : ($setup.newsLine)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: $setup.news?.at,
                                  class: _normalizeClass(["nge-hunt-news", [`nge-hunt-news--${$setup.newsLine.cls}`, { 'nge-hunt-news--ext': $setup.newsLine.ext }]]),
                                  role: "status"
                                }, [
                                  _createElementVNode("span", _hoisted_82, _toDisplayString($setup.newsLine.head), 1 /* TEXT */),
                                  _createElementVNode("span", _hoisted_83, _toDisplayString($setup.newsLine.text), 1 /* TEXT */),
                                  ($setup.newsLine.other && $setup.kinds.includes($setup.newsLine.other))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "nge-hunt-news-switch",
                                        onClick: _cache[11] || (_cache[11] = $event => ($setup.choose($setup.newsLine.other)))
                                      }, "Switch to " + _toDisplayString($setup.KIND[$setup.newsLine.other].word), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                                ], 2 /* CLASS */))
                              : _createCommentVNode("v-if", true),
                          ($setup.earlier.length && !$setup.mini)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_84, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.earlier, (e) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: e.at,
                                    class: _normalizeClass([`nge-hunt-log--${e.cls}`, { 'nge-hunt-log--ext': e.ext }])
                                  }, [
                                    _createElementVNode("b", null, _toDisplayString(e.head), 1 /* TEXT */),
                                    _createTextVNode(" " + _toDisplayString(e.text), 1 /* TEXT */)
                                  ], 2 /* CLASS */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" Done "),
                          ($setup.run.done && !$setup.mini)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 7,
                                class: _normalizeClass(["nge-hunt-done", { 'nge-hunt-done--all': $setup.run.found === $setup.run.of }])
                              }, [
                                _createElementVNode("div", _hoisted_85, _toDisplayString($setup.doneWhy.head), 1 /* TEXT */),
                                _createElementVNode("p", _hoisted_86, _toDisplayString($setup.doneWhy.text), 1 /* TEXT */),
                                _createElementVNode("p", null, [
                                  _createTextVNode(_toDisplayString($setup.run.found) + "/" + _toDisplayString($setup.run.of) + " found", 1 /* TEXT */),
                                  ($setup.yourTime)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" · " + _toDisplayString($setup.yourTime), 1 /* TEXT */)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                (!$setup.hunt.test)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_87, "Medals at the end, " + _toDisplayString($setup.localTime($setup.hunt.end_at)) + ".", 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ], 2 /* CLASS */))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" A problem the answers missed, sent by where it is and what it is (Ames 2026-10-26: \"submit a missed\n             thing that lets me plug in coords and label cut or merge\"). No gem used; an admin checks it. "),
                    ($setup.opened && $setup.phase !== 'announced' && !$setup.hunt.test && !$setup.mini)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("button", {
                            class: "nge-hunt-reportopen",
                            "aria-expanded": $setup.reportOpen,
                            onClick: _cache[12] || (_cache[12] = $event => ($setup.reportOpen = !$setup.reportOpen))
                          }, [
                            _createTextVNode("Found a problem the Hunt missed? "),
                            _createElementVNode("span", _hoisted_89, _toDisplayString($setup.reportOpen ? '▴' : '▾'), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_88),
                          ($setup.reportOpen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                _hoisted_91,
                                _createElementVNode("div", _hoisted_92, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (($setup.reportXyz) = $event)),
                                    class: "nge-hunt-reportxyz",
                                    placeholder: "x, y, z",
                                    "aria-label": "x, y, z",
                                    spellcheck: "false"
                                  }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, $setup.reportXyz]
                                  ]),
                                  _createElementVNode("button", {
                                    class: "nge-hunt-missed-go",
                                    onClick: $setup.reportFromCrosshair
                                  }, "Use the crosshair")
                                ]),
                                _createElementVNode("div", _hoisted_93, [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.REPORT_KINDS, (k) => {
                                    return _createElementVNode("button", {
                                      key: k,
                                      class: _normalizeClass(["nge-hunt-kind", [`nge-hunt-kind--${k}`, { 'nge-hunt-kind--on': $setup.reportKind === k }]]),
                                      role: "radio",
                                      "aria-checked": $setup.reportKind === k,
                                      onClick: $event => ($setup.reportKind = k)
                                    }, [
                                      _hoisted_95,
                                      _createElementVNode("span", _hoisted_96, _toDisplayString(k === 'cut' ? 'Cut' : 'Merge'), 1 /* TEXT */)
                                    ], 10 /* CLASS, PROPS */, _hoisted_94)
                                  }), 64 /* STABLE_FRAGMENT */))
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($setup.reportNote) = $event)),
                                  class: "nge-hunt-reportxyz",
                                  maxlength: "200",
                                  placeholder: "A note for the admins (optional)",
                                  "aria-label": "A note for the admins"
                                }, null, 512 /* NEED_PATCH */), [
                                  [_vModelText, $setup.reportNote]
                                ]),
                                _createElementVNode("button", {
                                  class: _normalizeClass(["nge-hunt-submit", { 'nge-hunt-submit--sent': $setup.reportJustSent }]),
                                  disabled: $setup.reportSending,
                                  onClick: $setup.sendReport
                                }, _toDisplayString($setup.reportSending ? 'Sending…' : $setup.reportJustSent ? '✓ Sent' : 'Send to the admins'), 11 /* TEXT, CLASS, PROPS */, _hoisted_97),
                                ($setup.reportSent)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_98, _toDisplayString($setup.reportSent), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    (!$setup.mini)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["nge-hunt-btn", { 'nge-hunt-btn--primary': !$setup.opened }]),
                            disabled: !!$setup.busy,
                            onClick: $setup.go
                          }, [
                            _createTextVNode(_toDisplayString($setup.busy === 'go' ? 'Opening…' : $setup.onDataset && $setup.opened ? 'Back to the start view' : 'Open the Hunt') + " ", 1 /* TEXT */),
                            (!$setup.onDataset && $setup.busy !== 'go')
                              ? (_openBlock(), _createElementBlock("small", _hoisted_101, "switches to " + _toDisplayString($setup.datasetName), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ], 10 /* CLASS, PROPS */, _hoisted_100),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(($setup.opened && $setup.somaCells.length > 1 ? $setup.somaCells : []), (c, i) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: c.root,
                              class: "nge-hunt-cellbtn",
                              title: c.label || `Cell ${i + 1}`,
                              onClick: $event => ($setup.goToSoma(c.soma || []))
                            }, "Cell " + _toDisplayString(i + 1), 9 /* TEXT, PROPS */, _hoisted_102))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : ($setup.phase === 'ended')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createCommentVNode(" The end: a celebration (Ames 2026-10-21: \"this shouldn't say awards ceremony, make it more congratulatory\") "),
                      _createElementVNode("div", _hoisted_103, [
                        _createCommentVNode(" Two set lines, not a wrap (Ames 2026-10-22: \"no comma after congratulations\", \"better type design on the title\") "),
                        _hoisted_104,
                        _createElementVNode("p", null, _toDisplayString($setup.hunt.players ? `${$setup.hunt.players === 1 ? '1 hunter' : `${$setup.hunt.players} hunters`} took part` : 'The Hunt is over'), 1 /* TEXT */)
                      ]),
                      (!$setup.hunt.awarded)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_105, "The medals are being given…"))
                        : _createCommentVNode("v-if", true),
                      ($setup.myResult && $setup.myResult.tier)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["nge-hunt-mymedal", `nge-hunt-mymedal--${$setup.myResult.tier}`])
                          }, [
                            _createElementVNode("img", {
                              src: $setup.medalArt($setup.myResult.tier),
                              alt: ""
                            }, null, 8 /* PROPS */, _hoisted_106),
                            _createElementVNode("div", null, [
                              _createElementVNode("b", {
                                class: _normalizeClass(`nge-hunt-tierword--${$setup.myResult.tier}`)
                              }, _toDisplayString($setup.TIER_WORD[$setup.myResult.tier]) + " is yours!", 3 /* TEXT, CLASS */),
                              _createElementVNode("span", null, _toDisplayString($setup.myResult.found) + "/" + _toDisplayString($setup.myResult.of) + " found · " + _toDisplayString($setup.myResult.gems) + " gems", 1 /* TEXT */)
                            ])
                          ], 2 /* CLASS */))
                        : ($setup.myResult)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_107, _toDisplayString($setup.myResult.found) + "/" + _toDisplayString($setup.myResult.of) + " found · " + _toDisplayString($setup.myResult.gems) + " gems. Thanks for hunting!", 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                      ($setup.hunt.fastest)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                            _hoisted_109,
                            _createElementVNode("div", null, [
                              _createElementVNode("b", null, "Fastest: " + _toDisplayString($setup.hunt.fastest.you ? 'you!' : $setup.hunt.fastest.name), 1 /* TEXT */),
                              _createElementVNode("span", null, _toDisplayString($setup.fastestShort), 1 /* TEXT */)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Where every merger and extension was (Ames 2026-10-26), unless the Hunt keeps its answers "),
                      ($setup.hunt.answers && !$setup.hunt.test)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            class: "nge-hunt-btn nge-hunt-answersbtn",
                            disabled: $setup.busy === 'answers',
                            onClick: $setup.toggleAnswers
                          }, _toDisplayString($setup.answersShown ? 'Hide the answers' : $setup.busy === 'answers' ? 'Showing the answers…' : 'Show the answers'), 9 /* TEXT, PROPS */, _hoisted_110))
                        : _createCommentVNode("v-if", true),
                      ($setup.answersShown && $setup.answersNote)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_111, _toDisplayString($setup.answersNote), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
              ($setup.error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_112, _toDisplayString($setup.error), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" Instructions, as Cell Library shows them (Ames 2026-10-21): a small link that opens a panel with the\n           Hunt's description, Ames's five lines (admins can change them in the game, EditableText), and the\n           medals in one slim row at the bottom (\"we can put tiers at bottom of instructions\"). Open before the\n           Hunt is opened, folded while hunting. "),
              ($setup.phase !== 'ended' && !$setup.mini)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 6,
                    class: _normalizeClass(["nge-hunt-howtoggle", { 'nge-hunt-howtoggle--open': $setup.howOpen }]),
                    "aria-expanded": $setup.howOpen,
                    onClick: $setup.toggleHow
                  }, _hoisted_116, 10 /* CLASS, PROPS */, _hoisted_113))
                : _createCommentVNode("v-if", true),
              ($setup.howOpen && $setup.phase !== 'ended' && !$setup.mini)
                ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                    ($setup.description)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "nge-hunt-desc nge-hunt-desc--how",
                          innerHTML: $setup.description
                        }, null, 8 /* PROPS */, _hoisted_118))
                      : _createCommentVNode("v-if", true),
                    _createVNode($setup["EditableText"], {
                      "text-key": "howto.hunt",
                      original: $setup.HUNT_STEPS,
                      "list-class": "nge-hunt-howto-steps",
                      approval: "",
                      label: "Hunt instructions"
                    }),
                    _createCommentVNode(" What the colors mean (Ames 2026-10-26): the gems' own colors, and the glow on a cell "),
                    _createElementVNode("div", _hoisted_119, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.GEM_KEY, (k) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: k.words,
                          class: "nge-hunt-keyitem"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(k.colors, (c) => {
                            return (_openBlock(), _createElementBlock("svg", {
                              key: c,
                              viewBox: "0 0 24 24",
                              width: "13",
                              height: "13",
                              "aria-hidden": "true"
                            }, [
                              _createElementVNode("path", {
                                d: "M5 9 L9 4 L15 4 L19 9 L12 20 Z",
                                fill: c
                              }, null, 8 /* PROPS */, _hoisted_120)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _createTextVNode(" " + _toDisplayString(k.words), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      ($setup.hunt.bounds_nm)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_121, [
                            _createElementVNode("i", {
                              class: "nge-hunt-keyglow",
                              style: _normalizeStyle({ '--edge': $setup.EDGE_COLOR }),
                              "aria-hidden": "true"
                            }, null, 4 /* STYLE */),
                            _createTextVNode(" A teal glow on a cell: the data ends there. An Extend gem there costs nothing. ")
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_122, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.TIERS, (t) => {
                        return _createElementVNode("span", {
                          key: t,
                          class: "nge-hunt-medalmini",
                          title: `${$setup.TIER_WORD[t]}: ${$setup.needShort(t)}`
                        }, [
                          _createElementVNode("img", {
                            src: $setup.medalArt(t),
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_124),
                          _createElementVNode("b", {
                            class: _normalizeClass(`nge-hunt-tierword--${t}`)
                          }, _toDisplayString($setup.TIER_WORD[t]), 3 /* TEXT, CLASS */),
                          _createElementVNode("small", null, _toDisplayString($setup.needShort(t)), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_123)
                      }), 64 /* STABLE_FRAGMENT */)),
                      _hoisted_125
                    ]),
                    (!$setup.hunt.test)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_126, _toDisplayString(($setup.hunt.cell_count || 1) > 1 ? 'The cells are' : 'The cell is') + " frozen while the Hunt runs: nobody can merge or cut " + _toDisplayString(($setup.hunt.cell_count || 1) > 1 ? 'them' : 'it') + ".", 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              ($setup.hunt.board.length && $setup.phase !== 'announced' && !$setup.mini)
                ? (_openBlock(), _createElementBlock("section", _hoisted_127, [
                    _createElementVNode("div", _hoisted_128, _toDisplayString($setup.phase === 'ended' ? 'Everyone who took part' : 'Top hunters'), 1 /* TEXT */),
                    _createElementVNode("ol", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hunt.board, (b) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: b.rank,
                          class: _normalizeClass({ 'nge-hunt-board--you': b.you })
                        }, [
                          _createElementVNode("span", _hoisted_129, _toDisplayString(b.rank), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_130, _toDisplayString(b.name), 1 /* TEXT */),
                          (b.fastest)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_131))
                            : _createCommentVNode("v-if", true),
                          (b.tier && $setup.phase === 'ended')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: _normalizeClass(["nge-hunt-tierdot", `nge-hunt-tierdot--${b.tier}`]),
                                title: $setup.TIER_WORD[b.tier]
                              }, null, 10 /* CLASS, PROPS */, _hoisted_132))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" While it runs, found only: no gem counts (Ames 2026-10-26); the results show them, as the medals count them "),
                          _createElementVNode("span", _hoisted_133, [
                            _createTextVNode(_toDisplayString(b.found) + "/" + _toDisplayString($setup.hunt.target_count), 1 /* TEXT */),
                            ($setup.phase === 'ended')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_134, " · " + _toDisplayString(b.gems) + " " + _toDisplayString(b.gems === 1 ? 'gem' : 'gems'), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ])
                        ], 2 /* CLASS */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        : _createCommentVNode("v-if", true)
  ], 6 /* CLASS, STYLE */))
}